import { aboutInfo } from '@/mocks/articles';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function About() {
  return (
    <>
      <SchemaOrg
        type="Organization"
        data={{
          name: aboutInfo.brandName,
          description: aboutInfo.introduction,
          url: typeof window !== 'undefined' ? window.location.origin : '',
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            availableLanguage: ['Chinese'],
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `关于我们 - ${aboutInfo.brandName}`,
          description: aboutInfo.introduction,
          inLanguage: 'zh-CN',
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: typeof window !== 'undefined' ? window.location.origin + '/' : '' },
            { '@type': 'ListItem', position: 2, name: '关于我们' },
          ],
        }}
      />
      <div className="py-8 md:py-12 bg-background-50">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '关于我们' }]} />

          <section className="mt-8">
            <h1 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
              关于 {aboutInfo.brandName}
            </h1>
            <p className="mt-2 text-sm text-foreground-500">{aboutInfo.slogan}</p>
            <p className="mt-6 text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl">
              {aboutInfo.introduction}
            </p>
          </section>

          <section className="mt-14">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {aboutInfo.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/60 text-center"
                >
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.value}</div>
                  <div className="mt-1 text-xs md:text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          <section className="mt-14">
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">我们的使命</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl">
              {aboutInfo.mission}
            </p>
          </section>

          <section className="mt-14">
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">核心价值观</h2>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {aboutInfo.values.map((item) => (
                <div
                  key={item.title}
                  className="p-5 rounded-lg bg-background-100 border border-background-200/60"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <h3 className="mt-3 text-base font-medium text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs md:text-sm text-foreground-500 leading-relaxed">{item.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mt-14" id="contact">
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">联系我们</h2>
            <p className="mt-2 text-sm text-foreground-500">
              如有任何问题或建议，欢迎通过以下方式与我们取得联系
            </p>
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="p-5 rounded-lg bg-background-100 border border-background-200/60 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">电子邮箱</div>
                  <div className="mt-1 text-sm text-foreground-500">{aboutInfo.contact.email}</div>
                </div>
              </div>
              <div className="p-5 rounded-lg bg-background-100 border border-background-200/60 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">微信公众号</div>
                  <div className="mt-1 text-sm text-foreground-500">{aboutInfo.contact.wechat}</div>
                </div>
              </div>
              <div className="p-5 rounded-lg bg-background-100 border border-background-200/60 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 shrink-0">
                  <i className="ri-qq-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">QQ客服</div>
                  <div className="mt-1 text-sm text-foreground-500">{aboutInfo.contact.qq}</div>
                </div>
              </div>
              <div className="p-5 rounded-lg bg-background-100 border border-background-200/60 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-100 text-foreground-600 shrink-0">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">工作时间</div>
                  <div className="mt-1 text-sm text-foreground-500">{aboutInfo.contact.workingHours}</div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}